module.exports = __webpack_public_path__ + "img/barcode1.1cec23d5.png";